import { useMemo } from "react"
import { useApiData } from "./useApiData"
import { type DesignerUser } from "models/DesignerUser"
import { omit } from "lib/helpers"

const useDesignerUser = () => {
  const response = useApiData<DesignerUser>(`brands/`)
  return useMemo(
    () => ({ ...omit(response, `data`), designerUser: response.data }),
    [response]
  )
}

export default useDesignerUser
